import { apiClient } from '../client';
const ENDPOINTS = {
    INVOICES: '/invoices',
    CLIENT_INVOICES: '/invoices/client',
    BY_CONTACT: '/invoices/contact',
    UNPAIDS: '/invoices/unpaids',
};
export const invoicesService = {
    // Get all invoices with filters (admin/staff)
    getInvoices: (filters) => {
        const params = new URLSearchParams();
        if (filters?.contactId)
            params.append('contactId', filters.contactId);
        if (filters?.jobId)
            params.append('jobId', filters.jobId);
        if (filters?.status)
            params.append('status', filters.status);
        if (filters?.isPaid !== undefined)
            params.append('isPaid', filters.isPaid.toString());
        if (filters?.search)
            params.append('search', filters.search);
        if (filters?.page)
            params.append('page', filters.page.toString());
        if (filters?.pageSize)
            params.append('pageSize', filters.pageSize.toString());
        return apiClient.get(`${ENDPOINTS.INVOICES}?${params.toString()}`);
    },
    // Get invoices for the current client
    getClientInvoices: (isPaid) => {
        const params = isPaid !== undefined ? `?isPaid=${isPaid}` : '';
        return apiClient.get(`${ENDPOINTS.CLIENT_INVOICES}${params}`);
    },
    // Get invoices for a specific contact
    getInvoicesByContact: (contactId, isPaid) => {
        const params = isPaid !== undefined ? `?isPaid=${isPaid}` : '';
        return apiClient.get(`${ENDPOINTS.BY_CONTACT}/${contactId}${params}`);
    },
    // Get single invoice
    getInvoiceById: (id) => apiClient.get(`${ENDPOINTS.INVOICES}/${id}`),
    // Create invoice
    createInvoice: (data) => apiClient.post(ENDPOINTS.INVOICES, data),
    // Update invoice status (for payments)
    updateInvoiceStatus: (id, data) => apiClient.patch(`${ENDPOINTS.INVOICES}/${id}/status`, data),
    // Delete invoice
    deleteInvoice: (id) => apiClient.delete(`${ENDPOINTS.INVOICES}/${id}`),
    // Dashboard: unpaid invoices (isPaid === false)
    getUnpaidInvoices: () => apiClient.get(ENDPOINTS.UNPAIDS),
};
